import AppBar from "@material-ui/core/AppBar";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Toolbar from "@material-ui/core/Toolbar";
import * as React from "react";

import { SalaryoLogo } from "../Icons/SalaryoLogo/SalaryoLogo";
import MenuButtonContainer from "./MenuButton/MenuButtonContainer";
import { styles, StyleType } from "./styles";
import { AddMemberButton } from "./components/AddMemberButton";
import BranchSelectorContainer from "./components/BranchSelector/BranchSelectorContainer";
import { Fade } from "@material-ui/core";

interface IProps {
  coworkName?: string;
  isSignIn?: boolean;
  enableAddMember?: boolean;
  onAddMemberClicked?: () => void;
}

class HeaderComponent extends React.Component<IProps & WithStyles<StyleType>> {

  public renderHeaderMenu = () => {
    const { classes, onAddMemberClicked, coworkName, isSignIn, enableAddMember } = this.props;
    const addMemberButton = enableAddMember? <AddMemberButton onClick={onAddMemberClicked} />: '';
    const addBranchSelector = coworkName ? <Fade in={Boolean(coworkName)} mountOnEnter={true}>
        <div className={classes.profileAndLocationContainer}>
            <BranchSelectorContainer />
            <MenuButtonContainer className={classes.menuButton} />
        </div>
    </Fade> : <MenuButtonContainer myAccount={true} className={classes.signOut} />;
    return isSignIn? (<>
            <div className={classes.flex} />
            {addMemberButton}
            {addBranchSelector}
        </>
    ): '';

  };

  public render() {
    const { classes } = this.props;
    return (
        <div className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <SalaryoLogo className={classes.logo} />
            {this.renderHeaderMenu()}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export const Header = withStyles(styles)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx